import React from 'react';
import { Link } from 'react-router-dom';

import { Project } from '~screens/Dashboard/screens/Projects/types';
import Flags from '~screens/Dashboard/screens/Projects/components/Flags';
import ContentType from '~components/ContentType';
import StageProgress from '~components/StageProgress';
import PublicationBadge from '~components/PublicationBadge';

import styles from './styles.module.scss';

interface Props {
  action: Project;
  /** On a territory's map, that territory instead of all of the Acción's. */
  territoryName?: string;
  /** Highlights the action's marker on the map while the pointer or focus is on the card. */
  onHighlight: (id?: number) => void;
}

/** Map panel row for an Acción: territory, name, Tema and stage; opens its Ficha. */
const ActionCard = ({ action, territoryName, onHighlight }: Props) => {
  const territory = territoryName && action.territories.find(t => t.name === territoryName);
  const countries = ((territory || action).countriesFormatted || '').split(',').map(name => name.trim()).filter(Boolean);
  const territories = territory ? territory.name : action.territories.map(t => t.name).join(', ');
  const highlight = () => onHighlight(action.id);
  const clear = () => onHighlight(undefined);

  return (
    <Link
      to={`/actions/${encodeURIComponent(action.code)}/show`}
      className={styles.card}
      onMouseEnter={highlight}
      onMouseLeave={clear}
      onFocus={highlight}
      onBlur={clear}
    >
      <span className={styles.territory}>
        <span className={styles.flags}><Flags countries={countries} /></span>
        <span className={styles.territoryName} title={territories}>{territories}</span>
      </span>
      <span className={styles.name}>{action.name}</span>
      <PublicationBadge status={action.publicationStatus} />
      {action.themes.length > 0 && (
        <span className={styles.themes}>
          {action.themes.map(theme => (
            <ContentType key={theme.id} infrastructure={theme} dark className={styles.tag} textClass={styles.tagText} />
          ))}
        </span>
      )}
      <StageProgress order={action.stage.order} size="sm" />
    </Link>
  );
};

export default ActionCard;
